import { ReactElement } from "react";

import { Header } from "@sabre/spark-react-core";

interface ArgsForSecondaryNav {
  userName?: string;
}

const SecondaryNav = ({ userName = "" }: ArgsForSecondaryNav): ReactElement => {
  return (
    <Header.Nav>
      <Header.NavItem label={userName} skipItemActivation />
    </Header.Nav>
  );
};

export default SecondaryNav;
